import React from 'react';
import { Field } from 'formik';

import styles from './dueDiligenceFormStyles';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import AddRemoveForm from 'buyside/components/presentation/Form/AddRemoveForm/addRemoveForm';
import DocumentsForm from 'buyside/components/presentation/Form/DocumentsForm/documentsForm';

const {
  employerProfileDueDiligenceDocumentCategories,
  employerProfileServiceProviderCategories
} = require('buyside/util/constantsFromRails.json');

// NOTE: make sure to update the appropriate schema in util/fundProfileShowPageValidationSchemata

const DueDiligenceForm = () => {
  const renderServiceProvider = serviceProviderPath => (
    <div className={styles.serviceProviderMainArea}>
      <div className={styles.serviceProviderColumn}>
        <Field
          component={InputField}
          name={serviceProviderPath + '.category'}
          type="select"
          label="Category"
          options={employerProfileServiceProviderCategories}
        />
        <Field component={InputField} name={serviceProviderPath + '.contactName'} label="Name" />
        <Field
          component={InputField}
          name={serviceProviderPath + '.contactPhoneNumber'}
          label="Phone"
        />
      </div>
      <div className={styles.serviceProviderColumn}>
        <Field
          component={InputField}
          name={serviceProviderPath + '.firmName'}
          label="Firm Name (Provider)"
        />
        <Field component={InputField} name={serviceProviderPath + '.contactEmail'} label="Email" />
      </div>
    </div>
  );

  return (
    <div>
      <DocumentsForm
        title="Documents"
        attr="fundProfile.dueDiligenceDocuments"
        withCategory
        categories={employerProfileDueDiligenceDocumentCategories}
        withDescription
      />
      <div className={styles.serviceProviders}>
        <AddRemoveForm
          title="Service Providers"
          attr="fundProfile.serviceProviders"
          renderItem={renderServiceProvider}
          itemName="Service Provider"
          blankItem={{
            category: '',
            contactName: '',
            contactPhoneNumber: '',
            firmName: '',
            contactEmail: ''
          }}
        />
      </div>
    </div>
  );
};

export default DueDiligenceForm;
